<template>
    <section class="section-outline" v-if="taxHistoryData.length">
        <mvtCollapse :disable="disableCollapse" :isActive="isActive">
            <template v-slot:header="collapsible">
                <h2 class="f2 text-bold">{{molang('dpp.taxHistory.title')}} <sub class="sub">for {{dpp.geo.address}}</sub></h2>
                <div class="f5 text-gray" v-if="description" v-show="collapsible.collapsed">{{ description }}</div>
            </template>
            <template v-slot:default>
                <ul class="property-tax-history">
                    <li class="title">
                        <b>{{ molang('dpp.taxHistory.year') }}</b>
                        <b>{{ molang('dpp.taxHistory.propertyTaxes') }}</b>
                        <b>{{ molang('dpp.taxHistory.taxAssessment') }}</b>
                    </li>
                    <li class="desc" v-for="item in taxHistoryData" :key="item.key">
                        <span>{{ item.year }}</span>
                        <div>
                            <span>{{ item.taxAmount }}</span>
                            <span :class="getChangeClass(item.taxChange)" v-if="item.taxChange">{{ item.taxChange }}</span>
                        </div>
                        <div>
                            <span>{{ item.assessedValue }}</span>
                            <span :class="getChangeClass(item.assessedChange)" v-if="item.assessedChange">{{ item.assessedChange }}</span>
                        </div>
                    </li>
                </ul>
            </template>
        </mvtCollapse>
    </section>
</template>
<script src="./property-tax-history.js"></script>

<style lang="scss">
@use './property-tax-history.scss' as *;
</style>
